<section class="bottom-nav">
    <article class="row bottom-nav__list">
        <div class="col-3 bottom-nav__item">
            <a routerLink="/events">
                <i class="far fa-calendar-check primary-text"></i>
                <p>{{ 'toolbars.liveEventsMenuOption' | translate }}</p>
            </a>
        </div>
        <div class="col-3 bottom-nav__item">
            <a routerLink="/workouts">
                <i class="fas fa-dumbbell primary-text"></i>
                <p>{{ 'toolbars.onDemandMenuOption' | translate }}</p>
            </a>
        </div>
        <div class="col-3 bottom-nav__item">
            <a [href]="accountUrl" target="_blank">
                <i class="fas fa-user-alt primary-text"></i>
                <p>{{ 'toolbars.userAccountMenuOption' | translate }}</p>
            </a>
        </div>
        <div class="col-3 bottom-nav__item">
            <a [href]="myDiscoveryUrl" target="_blank">
                <i class="fas fa-book primary-text"></i>
                <p>{{ 'toolbars.fitnessTrackerMenuOption' | translate }}</p>
            </a>
        </div>
    </article>
</section>
